import { render, staticRenderFns } from "./EditColumn.vue?vue&type=template&id=0a1382f9&"
import script from "./EditColumn.vue?vue&type=script&lang=js&"
export * from "./EditColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports